import { Controller } from "@hotwired/stimulus"
import { apiJson } from "../lib/api_errore"

// FiltriOpportunitaProgetto di components/FiltriOpportunitaProgetto.js (31a5bd1, delta 07 C7). Legge il profilo
// corrente del passo 1 (evento trova:profilo) e, 250 ms dopo l'ultimo cambio dei sette campi che contano, chiede le
// combinazioni a POST /api/opportunita/progetto/filtri; una risposta superata da un cambio successivo si scarta.
// Un errore resta un errore (mai «nessuna combinazione»): nessuna casella. Un'opzione scelta resta sempre
// rimovibile; le altre si disabilitano se la combinazione nota è vuota o il gruppo è pieno (6, spese 8). Ogni scelta
// esce con l'evento filtri-opportunita:cambia { key, value } (onChange dell'originale). I valori delle fonti entrano
// nella pagina solo come testo.
const TITOLO_SI = "Corrispondenze nelle classificazioni della fonte, da verificare sugli atti"
const TITOLO_NO = "Nessuna proposta censita con gli altri criteri; modifica le selezioni per ampliare la ricerca"
const ERRORE = "Combinazioni delle fonti non disponibili. Le classificazioni già proposte restano conservate; riprova prima di modificarle."
const BASE = "text-xs border rounded-full p-2"

export default class extends Controller {
  static targets = ["scelte", "errore", "attesa", "opzioni", "nota", "avviso", "dettagli"]

  connect() {
    this.corpo = null
    this.generazione = 0
    // il passo 1 aperto prima che questo controller fosse collegato (?project=): il profilo dal controller della pagina
    const trova = this.application.getControllerForElementAndIdentifier(this.element.closest("[data-controller~='trova']"), "trova")
    if (trova?.step === 1 && trova.p) this.aggiorna(trova.p)
  }

  disconnect() {
    this.ferma()
  }

  // lasciato il passo 1 il componente si smonta: al ritorno le combinazioni si richiedono di nuovo
  passo(event) {
    if (event.detail.step !== 1) { this.ferma(); this.corpo = null }
  }

  ferma() {
    this.generazione += 1
    clearTimeout(this.timer)
  }

  profilo(event) {
    this.aggiorna(event.detail.p)
  }

  aggiorna(p) {
    this.p = p
    const corpo = JSON.stringify({
      regione: p.regione || "", statoOpportunita: p.statoOpportunita || "attuali",
      settoriOpportunita: p.settoriOpportunita || [], beneficiariOpportunita: p.beneficiariOpportunita || [],
      formeOpportunita: p.formeOpportunita || [], obiettiviOpportunita: p.obiettiviOpportunita || [],
      costiOpportunita: p.costiOpportunita || [],
    })
    if (corpo !== this.corpo) {
      this.corpo = corpo
      this.ferma()
      this.facce = null
      this.errore = ""
      const generazione = this.generazione
      this.timer = setTimeout(() => {
        apiJson("/api/opportunita/progetto/filtri", { method: "POST", body: JSON.parse(corpo) })
          .then((data) => { if (generazione === this.generazione) { this.facce = data; this.disegna() } })
          .catch(() => { if (generazione === this.generazione) { this.errore = ERRORE; this.disegna() } })
      }, 250)
    }
    this.disegna()
  }

  disegna() {
    const p = this.p || {}
    this.scelteTargets.forEach((s) => { s.textContent = (p[s.dataset.chiave] || []).join(", ") || s.dataset.vuoto })
    this.element.querySelectorAll(":scope > [data-avviso-settore]").forEach((x) => x.remove())
    ;(p.avvisiSettore || []).forEach((a) => {
      const el = this.avvisoTarget.content.firstElementChild.cloneNode(true)
      el.dataset.avvisoSettore = ""
      el.textContent = a
      this.dettagliTarget.before(el)
    })
    this.erroreTarget.hidden = !this.errore
    this.erroreTarget.textContent = this.errore
    this.attesaTarget.hidden = !!(this.facce || this.errore)
    this.opzioniTargets.forEach((box) => {
      const key = box.dataset.chiave
      const max = Number(box.dataset.max)
      const scelti = p[key] || []
      box.replaceChildren(...((this.facce?.opzioni?.[key]) || []).map((o) => {
        const selected = scelti.includes(o.valore)
        const label = document.createElement("label")
        label.title = o.disponibile ? TITOLO_SI : TITOLO_NO
        label.className = `${BASE} ${selected ? "border-blue-600 bg-blue-50" : !o.disponibile ? "text-zinc-400 bg-zinc-100" : "bg-white"}`
        const input = document.createElement("input")
        input.type = "checkbox"
        input.checked = selected
        input.disabled = !selected && (!o.disponibile || scelti.length >= max)
        input.addEventListener("change", (e) => {
          const attuali = this.p[key] || []
          const value = e.target.checked ? [...attuali, o.valore] : attuali.filter((v) => v !== o.valore)
          this.dispatch("cambia", { detail: { key, value } })
        })
        label.append(input, ` ${o.valore} (${o.proposte}${o.da_verificare ? ` + ${o.da_verificare} da verificare` : ""})`)
        return label
      }))
    })
    this.notaTarget.hidden = !this.facce
    this.notaTarget.textContent = this.facce?.nota ?? ""
  }
}
